import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import classes from "../../style/Style.module.css";
import "../../style/Infoscreens.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../../libs/axiosConfig";
import Toast from "../../Components/ToastMsg/Toast";
import { selectPanNumber } from "../../Store/panNumberSlice";
import { useSelector } from "react-redux";
import { selectPhoneNumber } from "../../Store/MobileSlice";
import {
  ROUTE_PLACEOF_BIRTH,
  ROUTE_EMAIL,
  ROUTE_ACCOUNT_TYPE,
  Address_Verification,
  ROUTE_OCCUPATION,
  ROUTE_CHECKBOXES,
  Gender_Dob_Verification,
  ROUTE_MOBILE_VERIFICATION, ROUTE_NRI_Address,
  ROUTE_NOMINEE_DETAILS,
  ROUTE_NOMINEE_SENDOTP,
  ROUTE_DXTER_SCANNING,
} from "../../Routes";
import LogoutModal from "../../Components/LogoutModal";
import NewDexterLogo from "../../Images/NewDexterLogo.svg";

const BankMessagescreen = () => {
  const Navigate = useNavigate();
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const phoneNumber = useSelector(selectPhoneNumber);
  const panNumber = useSelector(selectPanNumber);
  const location = useLocation();
  const { BankMessage } = location.state || {};
  const [showModal, setShowModal] = useState(false);
  const [apiCallsInProgress, setApiCallsInProgress] = useState(0);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (apiCallsInProgress > 0) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);

  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };
  const HandleSubmit = async () => {
    setApiCallsInProgress(apiCallsInProgress + 1);

    const thirdApiResponse = await axios.post(
      "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
      {
        CustomerKycDetails: {
          request_type: "get",
          mobileNumber: phoneNumber,
          pan: panNumber,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${storedToken}`,
          // RefreshToken: refreshToken
        },
      }
    );

    // Assuming customerKycApiResponse contains the data
    const fullName = thirdApiResponse.data.body.panDetails.inv_name;
    const bankAccountHolderName_updated =
      thirdApiResponse.data.body.bankAccountHolderName;

    // Convert both values to lowercase
    const fullNameLowerCase = fullName.toLowerCase();
    const bankAccountHolderNameLowerCase =
      bankAccountHolderName_updated.toLowerCase();

    // Log the lowercase values
    console.log(fullNameLowerCase);
    console.log(bankAccountHolderNameLowerCase);

    // Compare the lowercase values and log the result
    if (fullNameLowerCase === bankAccountHolderNameLowerCase) {
      console.log("matches");
    } else {
      console.log("does not match");
    }

    if (
      thirdApiResponse.data.statusCode === 200 &&
      thirdApiResponse.data.status === true
    ) {
      console.log(thirdApiResponse.data.body);
      setApiCallsInProgress(apiCallsInProgress - 1);

      if (thirdApiResponse.data.body.emailId === "") {
        Navigate(ROUTE_EMAIL);
      } else if (
        thirdApiResponse.data.body.bankAccountNumber === "" ||
        thirdApiResponse.data.body.bankIfscCode === "" ||
        thirdApiResponse.data.body.bankAccountType === "" ||
        thirdApiResponse.data.body.bankName === "" ||
        thirdApiResponse.data.body.bankBranchName === "" ||
        thirdApiResponse.data.body.bankBranchAddress === "" ||
        thirdApiResponse.data.body.bankCodeNSE === "" ||
        thirdApiResponse.data.body.bankCodeBillDesk === "" ||
        thirdApiResponse.data.body.bankAccountHolderName === ""
      ) {
        console.log("from here it is redirecting");
        Navigate(ROUTE_ACCOUNT_TYPE);
      }
      // else if (
      //   bankVerified === null ||
      //   (bankVerified === " " &&
      //     bankVerified.account_exists !== "True" &&
      //     bankVerified.message !== "success. ")
      // ) {
      //   Navigate(ROUTE_ACCOUNT_TYPE);
      // } else if (
      //   customerKycApiResponse.data.data.bankVerified === null ||
      //   (customerKycApiResponse.data.data.bankVerified === " " &&
      //     customerKycApiResponse.data.data.bankVerified.account_exists !==
      //     "True" &&
      //     customerKycApiResponse.data.data.bankVerified.message !== "success. ")
      // ) {
      //   Navigate(ROUTE_ACCOUNT_TYPE);
      // }
      else if (
        thirdApiResponse.data.body.panDetails.gender === " " ||
        thirdApiResponse.data.body.panDetails.title === " " ||
        thirdApiResponse.data.body.panDetails.dob === " "
      ) {
        Navigate(Gender_Dob_Verification);
      } else if (
        thirdApiResponse.data.body.panDetails.addr1 === "" ||
        thirdApiResponse.data.body.panDetails.addr2 === "" ||
        thirdApiResponse.data.body.panDetails.city === "" ||
        thirdApiResponse.data.body.panDetails.state === "" ||
        thirdApiResponse.data.body.panDetails.pincode === "" ||
        thirdApiResponse.data.body.panDetails.country === "" ||
        thirdApiResponse.data.body.panDetails.fullAddress === ""
      ) {
        Navigate(Address_Verification);
      } else if (
        thirdApiResponse.data.body.nseIncomeCode === "" ||
        thirdApiResponse.data.body.nseIncomeCodeDescription === "" ||
        thirdApiResponse.data.body.nseOccupationCode === "" ||
        thirdApiResponse.data.body.nseOccupationCodeDescription === ""
      ) {
        Navigate(ROUTE_OCCUPATION);
      } else if (
        thirdApiResponse.data.body.placeOfBirth === "" ||
        thirdApiResponse.data.body.nseCountryCodeOfBirth === "" ||
        thirdApiResponse.data.body.nseCountryOfBirth === ""
      ) {
        Navigate(ROUTE_PLACEOF_BIRTH);
      } else if (
        thirdApiResponse.data.body.politicallyExposedPerson === "" ||
        thirdApiResponse.data.body.relatedToPoliticallyExposedPerson === ""
      ) {
        Navigate(ROUTE_CHECKBOXES);
      } else if (
        thirdApiResponse.data.body.nomineeDob !== "" &&
        thirdApiResponse.data.body.nomineeName === ""
      ) {
        Navigate(ROUTE_NOMINEE_DETAILS);
      } else if (
        thirdApiResponse.data.body.nomineeName !== "" &&
        thirdApiResponse.data.body.nomineeDob === ""
      ) {
        Navigate(ROUTE_NOMINEE_DETAILS);
      } else if (
        thirdApiResponse.data.body.nomineeName !== "" &&
        thirdApiResponse.data.body.nomineeType !== "" &&
        thirdApiResponse.data.body.nomineeRelationShip !== "" &&
        thirdApiResponse.data.body.nomineeDob !== "" &&
        thirdApiResponse.data.body.nomineeVerified === "N"
      ) {
        console.log("first");
        Navigate(ROUTE_NOMINEE_SENDOTP);
      }
      // else if (thirdApiResponse.data.body.nomineeName !== "" || customerKycApiResponse.data.data.nomineeName !== " " || customerKycApiResponse.data.data.nomineeName !== null ||
      //   thirdApiResponse.data.body.nomineeRelationShip !== "" || customerKycApiResponse.data.data.nomineeRelationShip !== " " || customerKycApiResponse.data.data.nomineeRelationShip !== null ||
      //   thirdApiResponse.data.body.nomineeAllocationPercentage !== "" || customerKycApiResponse.data.data.nomineeAllocationPercentage !== " " || customerKycApiResponse.data.data.nomineeAllocationPercentage !== null ||
      //   thirdApiResponse.data.body.nomineeDob !== "" || customerKycApiResponse.data.data.nomineeDob !== " " || customerKycApiResponse.data.data.nomineeDob !== null

      //   && (thirdApiResponse.data.body.nomineeGuardianName !== "" || customerKycApiResponse.data.data.nomineeGuardianName !== "" || customerKycApiResponse.data.data.nomineeGuardianName !== null || thirdApiResponse.data.body.nomineeGuardianPan !== "" || customerKycApiResponse.data.data.nomineeGuardianPan !== "" || customerKycApiResponse.data.data.nomineeGuardianPan !== null
      //   )

      //   && (thirdApiResponse.data.body.nomineeVerified === "N" || customerKycApiResponse.data.data.nomineeVerified === "N")) {
      //   Navigate(ROUTE_NOMINEE_SENDOTP)
      // }
      else {
        const requestBody = {
          dexterrCustomerBasicQuestions: {
            mobile_no: phoneNumber,
            request_type: "get",
            country_code: "+91",
          }
        };
        const headers = {
          Authorization: `Bearer ${storedToken}`,
          // RefreshToken: refreshToken
        };

        const secondApiResponse = await axios.post("https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc", requestBody, {
          headers: headers
        });
        if (secondApiResponse.data.data.resident !== "Resident Indian") {
          Navigate(ROUTE_NRI_Address)
        }
        else {
          Navigate(ROUTE_DXTER_SCANNING);
        }
      }
      console.log("here redirection")
      // Navigate(ROUTE_DXTER_SCANNING)


      // console.log("Third API call successful");
      // Toast.success("Third API call successful", "success");
      setApiCallsInProgress(apiCallsInProgress - 1);
    } else {
      // console.error("Third API call failed");
      Toast.error(
        thirdApiResponse.data.message + " " + thirdApiResponse.data.errorMessage
      );
      setApiCallsInProgress(apiCallsInProgress - 1);
    }
  };
  return (
    <div className="Bank_Main_Container">
      <div className="bank_Messages_Header">
        <ArrowBackIosIcon className="bank_Back_btn" onClick={HandleBack} />
        <div className="NewDexter_Logo">
          <img alt="" src={NewDexterLogo} className="DexterLogo" />
        </div> 
      </div>
      <div className="BlankText_Screen_Container">
        <p className="Input_Heading_text">{BankMessage}</p>
        <button className="Submit_button" onClick={HandleSubmit}>
          Proceed
        </button>
      </div>
      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
      <ToastContainer />
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
      ;
    </div>
  );
};

export default BankMessagescreen;
